import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_JOBS, PATH_PAY, PATH_REGISTER, PATH_AGENCY } from '../routes/paths';
// utils
import axios from 'axios';
import { isValidToken, setSession } from '../utils/jwt';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { push, pathname, query, asPath } = useRouter();
  const { user, logout, getUser } = useAuth();
  const { from, to } = query;
  const { enqueueSnackbar } = useSnackbar();

  const getNewQuery = (query) => {
    const newQuery = {
      ...query,
    };
    delete newQuery.ek;
    delete newQuery.ev;
    return newQuery;
  };

  const getUserByToken = async (ek, ev) => {
    const accessToken = window.localStorage.getItem('accessToken');
    if (accessToken && isValidToken(accessToken)) {
      setSession(accessToken);
      await getUser();
      push({ pathname, query: getNewQuery(query) }, undefined, { shallow: true });
    } else {
      try {
        const res = await axios.post(`${process.env.HOST_API_KEY}/api/accounts/ephemeral/`, {
          key: ek,
          value: Number.parseInt(ev),
        });
        setSession(res.data.t);
        await getUser();
        if (window.dataLayer) {
          window.dataLayer.push({'user_id': user.id, "event": "setUserId"});
        };
        push({ pathname, query: getNewQuery(query) }, undefined, { shallow: true });
      } catch (error) {
        push({
          pathname: PATH_AUTH.login,
          query : {
            ...getNewQuery(query),
            from: asPath,
          },
        });
      }
    }
  };

  useEffect(() => {    
    if (user && !user.is_employee) {
      if (window.dataLayer) {
        window.dataLayer.push({'user_id': user.id, "event": "setUserId"});
      }
      push({
        pathname: PATH_REGISTER.position,
        query
      });
    } else if (user && user.is_employee) {
      if (window.dataLayer) {
        window.dataLayer.push({'user_id': user.id, "event": "setUserId"});
      }
      if (user?.employee?.company.length === 0) {
        enqueueSnackbar('계정에 연결된 회사가 없습니다. 관리자에 문의해주세요.', { variant: 'error' });
        logout();
        push({
          pathname: PATH_AUTH.login,
          query
        })
        return ;
      }
      const status = user?.employee?.company?.[0]?.status
      if (status === 'position-selected') {
        if (to == 'position') {
          push({
            pathname: PATH_REGISTER.position,
          })
        } else {
          push({
            pathname: PATH_REGISTER.company,
            query
          })
        }
        return ;
      } else if (status === 'info-updated' || status === 'meeting-requested' || status === 'meeting-scheduled') {
        const needOutsourcing = user?.employee?.company?.[0]?.need_outsourcing;
        if (needOutsourcing) {
          push({
            pathname: PATH_REGISTER.project,
            query
          })
          return ;
        } else {
          push({
            pathname: PATH_REGISTER.meeting,
            query
          })
          return ;
        }
      } else if (status === 'decline-agency') {
        push({
          pathname: PATH_AGENCY.root,
          query
        })
        return ;
      }
      if (user.email === 'pg@dio.so') {
        // for pg test
        push({
          pathname: PATH_PAY.root,
        })
      } else if (from) {
        push(from);
      } else {
        push({
          pathname: PATH_JOBS.root,
          query: { ...query }
        });
      }
    } else if (pathname !== PATH_AUTH.register && pathname !== PATH_AUTH.login) {
      if (query.ek && query.ev) {
        getUserByToken(query.ek, query.ev);
      } else {
        push({
          pathname: PATH_AUTH.login,
          query: { ...query, from: asPath, }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return <>{children}</>;
}
